//Release 2 Budget Management requirement
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { showModal, toggleShowInEur } from "../actions";
import {
  GlobalMessages,
  Header,
  Budget,
  Table,
  TableHeadingWrap,
  TableActionsWrap,
  TableAction,
} from "../components";
import { columns } from "../util/config";

const BudgetManage = (props) => {
  const { messages, showModal, account, config } = props;
  const { roles, accessibles } = account;
  console.log("budgetmanageemnt", accessibles);
  const isGct = roles.includes("gct");
  const isManager = roles.includes("manager");
  const isSuperManager = roles.includes("supermanager");
  const isAdmin = roles.includes("admin");
  const isBCB = roles.includes("bcb");
  const currentYear = new Date().getFullYear();
  const nextYear = new Date().getFullYear() + 1;

  /*  HR3_ROLE */
  const isHr =
    roles.includes("hr1") ||
    roles.includes("hr2") ||
    roles.includes("hr3") ||
    roles.includes("hr3") ||
    /* DEM0083831 - N4 Starts */
    roles.includes("hr4") ||
    /* DEM0083831 - N4 Ends */
    roles.includes("rcb") ||
    roles.includes("chr") ||
    roles.includes("hrc") ||
    roles.includes("bcb") ||
    roles.includes("rhr");
  const [tableQuery, setTableQuery] = useState("budgetsForAdmin");
  const [tableWhere, setTableWhere] = useState(null);
  const [tablesearch, setSearchValue] = useState(null);
  const [tableCurrentYear, setTableYear] = useState(currentYear.toString());
  const [tableReload, reloadTable] = useState(false);

  const hasGlobalMessages = messages.length > 0;

  const hasBudgetVisibility =
    (accessibles && accessibles.budgetOrgs.length > 0) || isGct || isAdmin;
  const visible = isGct || isAdmin || isBCB;

  const handleRequestOneTime = (event) => {
    showModal({ component: "newbudget", content: tableCurrentYear });
  };

  const handleEditBudget = (value) => {
    console.log(value);
    //showModal([{ component: 'editbudget' },{content : value}]);
    showModal({ component: "editbudget", content: value });
  };

  const onChange = (event) => setSearchValue(event.target.value);

  const onYearChanged = (event) => {
    setTableYear(event.target.value);
    console.log(tableCurrentYear);
  };

  return (
    <div style={{ fontSize: "0.8rem" }}>
      <input id="searchResult" style={{ display: "none" }} />
      <Header {...props} />
      {hasBudgetVisibility && <Budget {...props} />}
      {hasGlobalMessages && <GlobalMessages />}
      <TableHeadingWrap
        style={{ justifyContent: "center", marginBlockEnd: "1em" }}
      >
        <div
          style={{
            width: "22%",

            display: "flex",
            justifyContent: "left",
            gap: "10px",
            alignItems: "baseline",
            borderRight: "2px solid rgba(128, 128, 128, 0.63)",
          }}
        >
          <h2
            style={{
              marginBlockStart: "0em",
              marginBlockEnd: "0em",
            }}
          >
            Offcycle Budget Management
          </h2>
        </div>
        {visible && (
          <div
            style={{
              width: "20%",
              display: "flex",
              justifyContent: "center",
              fontWeight: "500",
              fontSize: "15px",
              gridGap: "10px",
              alignItems: "baseline",
              borderRight: "2px solid #808080a1",
            }}
          >
            <label>Search : </label>
            <input
              placeholder="Organisation name"
              style={{
                border: "2px solid #80808063",
                borderRadius: "5px",
                height: "30px",
              }}
              type="search"
              onChange={onChange}
            />
          </div>
        )}
        {visible && (
          <div
            style={{
              width: "48%",
              display: "flex",
              justifyContent: "left",
              paddingLeft: "2%",
              fontWeight: "500",
              fontSize: "15px",
              gridGap: "10px",
            }}
          >
            {" "}
            <label>Select Year : </label>
            <input
              style={{
                border: "1px solid black",
                height: "1rem",
                padding: "0.4em",
              }}
              type="radio"
              id="cyear"
              value={currentYear}
              onChange={onYearChanged}
              checked={tableCurrentYear === currentYear.toString()}
            ></input>
            <label for="cyear">{currentYear}</label>
            <input
              style={{
                border: "1px solid black",
                height: "1rem",
                padding: "0.4em",
              }}
              type="radio"
              id="nyear"
              value={nextYear}
              onChange={onYearChanged}
              checked={tableCurrentYear === nextYear.toString()}
            ></input>
            <label for="nyear">{nextYear}</label>
          </div>
        )}

        {(isGct || isAdmin) && (
          <TableActionsWrap>
            <TableAction onClick={handleRequestOneTime}>
              Add Budget for {tableCurrentYear}
            </TableAction>
          </TableActionsWrap>
        )}
      </TableHeadingWrap>

      <Table
        recordType="budgetmanage"
        columns={columns.budgetmanage}
        query={tableQuery}
        where={
          isBCB
            ? tablesearch && tablesearch.trim().length != 0
              ? {
                  OR: [
                    {
                      organization_unit_name: {
                        contains: tablesearch.toString(),
                      },
                    },
                    {
                      parent_organization_unit_name: {
                        contains: tablesearch.toString(),
                      },
                    },
                  ],
                  parent_organization_unit: { in: accessibles.budgetOrgs },
                  year: { eq: tableCurrentYear.toString() },
                }
              : {
                  parent_organization_unit: { in: accessibles.budgetOrgs },
                  year: { eq: tableCurrentYear.toString() },
                }
            : tablesearch && tablesearch.trim().length != 0
            ? {
                OR: [
                  {
                    organization_unit_name: {
                      contains: tablesearch.toString(),
                    },
                  },
                  {
                    parent_organization_unit_name: {
                      contains: tablesearch.toString(),
                    },
                  },
                ],
                year: { eq: tableCurrentYear.toString() },
              }
            : { year: { eq: tableCurrentYear.toString() } }
        }
        Budgetfilter={tablesearch}
        editOnClick={handleEditBudget}
        config={config}
        account={account}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    account: state.account,
    messages: state.messages,
    config: state.config,
  };
};

export default connect(mapStateToProps, { showModal, toggleShowInEur })(
  BudgetManage
);
